import { useContext } from 'react';
import { ResourceContext } from '../Resource';

export const useDataProvider = () => {
  const { dataProvider } = useContext(ResourceContext);
  return (dataProviderName) => {
    if (dataProviderName) {
      const provider = dataProvider[dataProviderName];
      if (!provider && dataProvider.defaullt) return dataProvider.defaullt;
      if (dataProvider) return dataProvider;
      throw new Error(`"${dataProviderName}" Data provider not found`);
    }
    return dataProvider.default || dataProvider;
  };
};
